import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { jsPDF } from "jspdf";
import JsBarcode from "jsbarcode";
import logoData from './logo.json';
import candadoData from './candado.json';
import { crearRecibo } from "../api";

const UserPagoVerForm = ({ user, getPagosByUser_Id, nombre_completo }) => {
  const [pagosList, setPagosList] = useState([]);

  useEffect(() => {
    const fetchPagos = async () => {
      if (!user) return;
      try {
        const pagosData = await getPagosByUser_Id(user);
        setPagosList(Array.isArray(pagosData.data) ? pagosData.data : []);
      } catch (error) {
        console.error("Error fetching pagos:", error);
        setPagosList([]);
      }
    };

    fetchPagos();
  }, [user, getPagosByUser_Id]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const utcDate = new Date(dateString);
    const localDate = new Date(utcDate.getTime() + 24 * 60 * 60 * 1000);
    return localDate.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const getPeriodoActivo = () => {
    const fechaActual = new Date();
    const año = fechaActual.getFullYear();
    const mes = fechaActual.getMonth() + 1;
    if (mes >= 1 && mes <= 3) return `cuota ene-mar ${año}`;
    if (mes >= 4 && mes <= 6) return `cuota abr-jun ${año}`;
    if (mes >= 7 && mes <= 9) return `cuota jul-sep ${año}`;
    return `cuota oct-dic ${año}`;
  };

  const periodoActivo = getPeriodoActivo();
  const haPagadoPeriodoActivo = pagosList.some(p => p.motivo_de_pago === periodoActivo);

  const generatePDF = async (pago, backgroundColor) => {
    const data = {};
    data['id_usuario'] = user;
    data['motivo_de_pago'] = pago.motivo_de_pago;
    await crearRecibo(data); 

    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });
  
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const halfPageHeight = pageHeight / 2;
 
    // --- 🔥 PARTE 1: Número de carrera (arriba)
   
    // 👉 Logo
    if (logoData?.base64) {
      doc.addImage(logoData.base64, 'PNG', 5, 5, 45, 45);
    }
   
    // 👉 Número de corredor
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(240);
    doc.text(`${user}`, pageWidth / 2, 90, { align: 'center' });
  
 
    // 👉 Nombre abajo
    doc.setFontSize(35);
    doc.text(`${nombre_completo.split(" ")[0]}`, pageWidth / 2, halfPageHeight - 25, { align: 'center' });

    doc.text(`${pago.motivo_de_pago.replace('cuota ', '')}`, pageWidth / 2, halfPageHeight - 15, { align: 'center' });
  
    // 👉 Línea divisoria
    doc.line(10, 110, pageWidth - 10, 110);
    doc.setLineWidth(0.5);
    doc.setLineDashPattern([1, 1], 0); // [dash length, gap length]
    doc.line(10, 140, pageWidth - 10, 140);

    doc.setLineDashPattern([], 0); // Reset to solid lines if needed afterward
    // --- 🔥 PARTE 2: Credencial (abajo)
  
 
    // 👉 Marco credencial
    const credX = 20;
    const credY = halfPageHeight-5 ;
    const credWidth = 85;
    const credHeight = 54;

    // Fondo Candado
    doc.setFillColor(backgroundColor); // RGB
    doc.rect(130, credY, 60, 140, 'F');
      
    if (candadoData?.base64) {
      doc.addImage(candadoData.base64, 'PNG', 130, credY, 60, 140);
    }


    if (logoData?.base64) {
      doc.addImage(logoData.base64, 'PNG', 145, credY + 100, 35, 35);
    }

    // --- 🔥 Código de Barras (user)
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, user.toString(), {
      format: "CODE128",
      width: 2,
      height: 20,
      displayValue: false,
      margin: 0,
    });
  
    const barcodeBase64 = canvas.toDataURL("image/png");
  
    const barcodeY = halfPageHeight + 70;

    doc.setFontSize(100);
    doc.setTextColor(255, 255, 255); // blanco
    doc.text(`${user}`, 160, credY + 90, { align: 'center' });

    doc.setFontSize(20);
    doc.text(`${pago.motivo_de_pago.replace('cuota ', '')}`, 160, credY + 105, { align: 'center' });

    doc.addImage(barcodeBase64, 'PNG', 140, barcodeY+18, 40, 5);
  
    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.rect(credX, credY, credWidth, credHeight);
  
    // 👉 Título credencial
    // 👉 Logo
    if (logoData?.base64) {
      doc.addImage(logoData.base64, 'PNG', 22, credY+3, 20, 20);
    }
  
    doc.setFontSize(14);
    doc.text("CREDENCIAL", 61, credY + 10, { align: 'center' });
    doc.text("HALCONES", 61, credY + 15, { align: 'center' });
  
    // 👉 Datos en la credencial
    let dataY = credY + 35;
    doc.setFontSize(18);
    doc.setTextColor(0, 0, 0);
    doc.text(`${nombre_completo.split(" ").slice(0, 2).join(" ")}`, credX + 3, dataY);
    dataY += 5;
    doc.text(`${pago.motivo_de_pago.replace('cuota ', '')}`, credX + 3, dataY);
    doc.setFontSize(10);
    dataY += 5;
    doc.text(`Número de Usuario: ${user}`, credX + 3, dataY);
    dataY += 5;
    doc.text(`Fecha de Registro de Pago: ${formatDate(pago.fecha_pago)}`, credX + 3, dataY);
  
    // 👉 Espacio para fotografía
    doc.setDrawColor(0);
    doc.rect(79, credY+2, 25, 30);
    doc.setFontSize(8);
    doc.text("Foto", 84, credY+7, { align: 'center' });

    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.rect(credX, credY+54, credWidth, credHeight);
  
      
    doc.addImage(barcodeBase64, 'PNG', 25, barcodeY, 75, 15);
    doc.text(`Valido durante: ${pago.motivo_de_pago.replace('cuota ', '')}`, credX + 5, barcodeY+20);
    doc.text(`Cuida tu salud en nuestra app `, credX + 5, barcodeY+25);
    doc.text(`https://halcones-sistema.negociolocalmx.com/`, credX + 5, barcodeY+30);

    // 👉 Logo
    if (logoData?.base64) {
      doc.addImage(logoData.base64, 'PNG', 25, 200, 18, 18);
    }

    doc.circle(10, 7, 3, 'F');
    doc.circle(200, 7, 3, 'F');
    doc.circle(10, 125, 3, 'F');
    doc.circle(200, 125, 3, 'F');

    // 👉 Guardar PDF
    doc.save(`numero_y_credencial_${nombre_completo.replace(/\s/g, "_")}_${formatDate(pago.fecha_pago)}.pdf`);
  };
  
  

  return (
    <div className="table-container">
      <h3>Pagos Encontrados de {nombre_completo}</h3>
      <table border="1" className="table">
        <thead className="table-th">
          <tr>
            <th>Fecha</th>
            <th>Motivo</th>
            <th>Cantidad</th>
            <th>Método</th>
            <th>Recibió</th>
            <th>Nota</th>
            <th>Recibo/ID</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(pagosList) && pagosList.length > 0 ? (
            pagosList.map((pago, index) => {
              const backgroundColor =
                pago.motivo_de_pago === "cuota ene-mar 2025" ? "#c5f7d7" :
                pago.motivo_de_pago === "cuota abr-jun 2025" ? "#17d4b4" :
                pago.motivo_de_pago === "cuota jul-sep 2025" ? "#2a9db1" :
                pago.motivo_de_pago === "cuota oct-dic 2025" ? "#3065b4" :
                pago.motivo_de_pago === "cuota ene-mar 2026" ? "#ffab3d" :
                pago.motivo_de_pago === "cuota abr-jun 2026" ? "#bd7e2d" :
                "rgba(170, 170, 170, 1)";

              const color = "#000";

              return (
                <tr key={index} style={{ backgroundColor, color }}>
                  <td>{formatDate(pago.fecha_pago)}</td>
                  <td width="200px">{pago.motivo_de_pago}</td>
                  <td><center>${pago.cantidad}</center></td>
                  <td>{pago.metodo_de_pago}</td>
                  <td>{pago.receptor}</td>
                  <td>{pago.nota}</td>
                  <td>
                    <button onClick={() => generatePDF(pago, backgroundColor)} className="button">Recibo</button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="7" style={{ backgroundColor: '#ff0000', color: 'white' }}>
                No hay aportaciones registradas.
              </td>
            </tr>
          )}
          {!haPagadoPeriodoActivo && (
            <tr>
              <td colSpan="7" style={{ backgroundColor: '#ff0000', color: 'white' }}>
                No se ha registrado el pago del período activo ({periodoActivo}).
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

UserPagoVerForm.propTypes = {
  user: PropTypes.number,
  getPagosByUser_Id: PropTypes.func.isRequired,
  nombre_completo: PropTypes.string.isRequired,
};

export default UserPagoVerForm;
